import './empty-state.css';
export default {
  "emptyState": "pf-v6-c-empty-state",
  "emptyStateActions": "pf-v6-c-empty-state__actions",
  "emptyStateBody": "pf-v6-c-empty-state__body",
  "emptyStateContent": "pf-v6-c-empty-state__content",
  "emptyStateFooter": "pf-v6-c-empty-state__footer",
  "emptyStateIcon": "pf-v6-c-empty-state__icon",
  "emptyStateTitleText": "pf-v6-c-empty-state__title-text",
  "modifiers": {
    "xs": "pf-m-xs",
    "sm": "pf-m-sm",
    "lg": "pf-m-lg",
    "xl": "pf-m-xl",
    "fullHeight": "pf-m-full-height",
    "danger": "pf-m-danger",
    "warning": "pf-m-warning",
    "success": "pf-m-success",
    "info": "pf-m-info",
    "custom": "pf-m-custom"
  }
};